module.exports = __webpack_public_path__ + "img/olt_7kl.f9526874.jpg";